export enum ChallengeSorting {
  NEWEST = 'newest',
  TRENDING = 'trend',
  OLDEST = 'oldest',
  POPULAR = 'mostPopular',
  COMMENTS = 'mostComments',
  RANDOM = 'random'
}
